/**
 * Country SEO i18n - Wave 5
 * Fills remaining gaps: mexico, colombia, argentina, ukraine, vietnam, greece, kenya, thailand, malaysia,
 * philippines, nigeria, egypt, south-africa, 'saudi-arabia', 'saudi-arabia-expanded'
 * Focus on SV, DA, KO, JA, TR, IT, PT, NL languages
 */

import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE5: CountrySEOMap = {

  // ============ MEXICO — expand to SV, DA, KO, JA, TR, IT ============
  mexico: {
    sv: {
      title: 'Callcenter för Mexiko | Spansktalande Kundtjänst | Call IT Dev',
      description: 'Callcenter för Mexiko: spanska agenter, CSAT 95%, från 3 $/h. 60% besparing.',
      heroTitle: 'Callcenter för Mexiko',
      heroSubtitle: 'Premium spansktalande kundtjänst till nearshore-priser.',
    },
    da: {
      title: 'Callcenter for Mexico | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Mexico: spanske agenter, CSAT 95%, fra 3 $/t. 60% besparelse.',
      heroTitle: 'Callcenter for Mexico',
      heroSubtitle: 'Premium spansktalende kundeservice til nearshore-priser.',
    },
    ko: {
      title: '멕시코 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '멕시코 콜센터: 원어민 스페인어 상담원, CSAT 95%, 시간당 $3부터. 60% 절감.',
      heroTitle: '멕시코 콜센터',
      heroSubtitle: '프리미엄 스페인어 고객 서비스.',
    },
    ja: {
      title: 'メキシコ向けコールセンター | スペイン語サポート | Call IT Dev',
      description: 'メキシコ向けコールセンター：ネイティブスペイン語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'メキシコ向けコールセンター',
      heroSubtitle: 'プレミアムスペイン語カスタマーサービス。',
    },
    tr: {
      title: 'Meksika Çağrı Merkezi | İspanyolca Müşteri Hizmetleri | Call IT Dev',
      description: 'Meksika çağrı merkezi: İspanyolca temsilciler, CSAT %95, saat başı 3$\'dan. %60 tasarruf.',
      heroTitle: 'Meksika Çağrı Merkezi',
      heroSubtitle: 'Premium İspanyolca müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Messico | Assistenza Clienti in Spagnolo | Call IT Dev',
      description: 'Call center per il Messico: agenti spagnoli, CSAT 95%, da 3 $/h. 60% risparmio.',
      heroTitle: 'Call Center per il Messico',
      heroSubtitle: 'Assistenza clienti premium in spagnolo.',
    },
  },

  // ============ COLOMBIA — expand to SV, DA, KO, JA, TR, IT, NL ============
  colombia: {
    sv: {
      title: 'Callcenter för Colombia | Spansktalande Support | Call IT Dev',
      description: 'Callcenter för Colombia: spanska agenter, CSAT 95%, från 3 $/h. 55% besparing.',
      heroTitle: 'Callcenter för Colombia',
      heroSubtitle: 'Premium spansktalande kundtjänst.',
    },
    da: {
      title: 'Callcenter for Colombia | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Colombia: spanske agenter, CSAT 95%, fra 3 $/t. 55% besparelse.',
      heroTitle: 'Callcenter for Colombia',
      heroSubtitle: 'Premium spansktalende kundeservice.',
    },
    ko: {
      title: '콜롬비아 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '콜롬비아 콜센터: 원어민 스페인어 상담원, CSAT 95%, 시간당 $3부터.',
      heroTitle: '콜롬비아 콜센터',
      heroSubtitle: '프리미엄 스페인어 고객 서비스.',
    },
    ja: {
      title: 'コロンビア向けコールセンター | スペイン語サポート | Call IT Dev',
      description: 'コロンビア向けコールセンター：スペイン語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'コロンビア向けコールセンター',
      heroSubtitle: 'プレミアムスペイン語カスタマーサービス。',
    },
    tr: {
      title: 'Kolombiya Çağrı Merkezi | İspanyolca Müşteri Hizmetleri | Call IT Dev',
      description: 'Kolombiya çağrı merkezi: İspanyolca temsilciler, CSAT %95, saat başı 3$\'dan.',
      heroTitle: 'Kolombiya Çağrı Merkezi',
      heroSubtitle: 'Premium İspanyolca müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Colombia | Assistenza in Spagnolo | Call IT Dev',
      description: 'Call center per la Colombia: agenti spagnoli, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per la Colombia',
      heroSubtitle: 'Assistenza clienti premium in spagnolo.',
    },
    nl: {
      title: 'Callcenter Colombia | Spaanstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Colombia: Spaanstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Colombia',
      heroSubtitle: 'Premium Spaanstalige klantenservice.',
    },
  },

  // ============ ARGENTINA — expand to SV, DA, KO, JA, TR, IT, NL ============
  argentina: {
    sv: {
      title: 'Callcenter för Argentina | Spansktalande Support | Call IT Dev',
      description: 'Callcenter för Argentina: spanska agenter, CSAT 95%, från 3 $/h. 55% besparing.',
      heroTitle: 'Callcenter för Argentina',
      heroSubtitle: 'Premium spansktalande kundtjänst.',
    },
    da: {
      title: 'Callcenter for Argentina | Spansktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Argentina: spanske agenter, CSAT 95%, fra 3 $/t. 55% besparelse.',
      heroTitle: 'Callcenter for Argentina',
      heroSubtitle: 'Premium spansktalende kundeservice.',
    },
    ko: {
      title: '아르헨티나 콜센터 | 스페인어 고객 서비스 | Call IT Dev',
      description: '아르헨티나 콜센터: 원어민 스페인어 상담원, CSAT 95%, 시간당 $3부터.',
      heroTitle: '아르헨티나 콜센터',
      heroSubtitle: '프리미엄 스페인어 고객 서비스.',
    },
    ja: {
      title: 'アルゼンチン向けコールセンター | スペイン語サポート | Call IT Dev',
      description: 'アルゼンチン向けコールセンター：スペイン語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'アルゼンチン向けコールセンター',
      heroSubtitle: 'プレミアムスペイン語カスタマーサービス。',
    },
    tr: {
      title: 'Arjantin Çağrı Merkezi | İspanyolca Müşteri Hizmetleri | Call IT Dev',
      description: 'Arjantin çağrı merkezi: İspanyolca temsilciler, CSAT %95, saat başı 3$\'dan.',
      heroTitle: 'Arjantin Çağrı Merkezi',
      heroSubtitle: 'Premium İspanyolca müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Argentina | Assistenza in Spagnolo | Call IT Dev',
      description: 'Call center per l\'Argentina: agenti spagnoli, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per l\'Argentina',
      heroSubtitle: 'Assistenza clienti premium in spagnolo.',
    },
    nl: {
      title: 'Callcenter Argentinië | Spaanstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Argentinië: Spaanstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Argentinië',
      heroSubtitle: 'Premium Spaanstalige klantenservice.',
    },
  },

  // ============ UKRAINE — expand to SV, DA, KO, JA, TR, IT, PT, NL ============
  ukraine: {
    sv: {
      title: 'Callcenter för Ukraina | Flerspråkig Support | Call IT Dev',
      description: 'Callcenter för Ukraina: affärskontinuitet, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för Ukraina',
      heroSubtitle: 'Affärskontinuitet och europeisk expansion.',
    },
    da: {
      title: 'Callcenter for Ukraine | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Ukraine: forretningskontinuitet, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter for Ukraine',
      heroSubtitle: 'Forretningskontinuitet og europæisk ekspansion.',
    },
    ko: {
      title: '우크라이나 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '우크라이나 콜센터: 사업 연속성, CSAT 95%, 시간당 $3부터.',
      heroTitle: '우크라이나 콜센터',
      heroSubtitle: '사업 연속성과 유럽 확장.',
    },
    ja: {
      title: 'ウクライナ向けコールセンター | 多言語サポート | Call IT Dev',
      description: 'ウクライナ向けコールセンター：事業継続性、CSAT 95%、時給3ドルから。',
      heroTitle: 'ウクライナ向けコールセンター',
      heroSubtitle: '事業継続性とヨーロッパ展開。',
    },
    tr: {
      title: 'Ukrayna Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Ukrayna çağrı merkezi: iş sürekliliği, CSAT %95, saat başı 3$\'dan.',
      heroTitle: 'Ukrayna Çağrı Merkezi',
      heroSubtitle: 'İş sürekliliği ve Avrupa genişlemesi.',
    },
    it: {
      title: 'Call Center Ucraina | Supporto Multilingue | Call IT Dev',
      description: 'Call center per l\'Ucraina: continuità aziendale, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per l\'Ucraina',
      heroSubtitle: 'Continuità aziendale ed espansione europea.',
    },
    pt: {
      title: 'Call Center Ucrânia | Suporte Multilíngue | Call IT Dev',
      description: 'Call center para a Ucrânia: continuidade de negócios, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para a Ucrânia',
      heroSubtitle: 'Continuidade de negócios e expansão europeia.',
    },
    nl: {
      title: 'Callcenter Oekraïne | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Oekraïne: bedrijfscontinuïteit, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Oekraïne',
      heroSubtitle: 'Bedrijfscontinuïteit en Europese expansie.',
    },
  },

  // ============ VIETNAM — expand to SV, DA, TR, IT, PT, NL ============
  vietnam: {
    sv: {
      title: 'Callcenter för Vietnam | Flerspråkig Support | Call IT Dev',
      description: 'Callcenter för Vietnam: engelska agenter, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för Vietnam',
      heroSubtitle: 'Flerspråkig kundtjänst för vietnamesiska företag.',
    },
    da: {
      title: 'Callcenter for Vietnam | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Vietnam: engelske agenter, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter for Vietnam',
      heroSubtitle: 'Flersproget kundeservice for vietnamesiske virksomheder.',
    },
    tr: {
      title: 'Vietnam Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Vietnam çağrı merkezi: İngilizce temsilciler, CSAT %95, saat başı 3$\'dan.',
      heroTitle: 'Vietnam Çağrı Merkezi',
      heroSubtitle: 'Vietnam şirketleri için çok dilli müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Vietnam | Supporto Multilingue | Call IT Dev',
      description: 'Call center per il Vietnam: agenti inglesi, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per il Vietnam',
      heroSubtitle: 'Supporto multilingue per aziende vietnamite.',
    },
    pt: {
      title: 'Call Center Vietnã | Suporte Multilíngue | Call IT Dev',
      description: 'Call center para o Vietnã: agentes em inglês, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para o Vietnã',
      heroSubtitle: 'Suporte multilíngue para empresas vietnamitas.',
    },
    nl: {
      title: 'Callcenter Vietnam | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Vietnam: Engelstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Vietnam',
      heroSubtitle: 'Meertalige klantenservice voor Vietnamese bedrijven.',
    },
  },

  // ============ GREECE — expand to SV, DA, KO, JA, TR, NL ============
  greece: {
    sv: {
      title: 'Callcenter för Grekland | Flerspråkig Support | Call IT Dev',
      description: 'Callcenter för Grekland: europeiska språk, CSAT 95%, från 3 $/h. 55% besparing vs Aten.',
      heroTitle: 'Callcenter för Grekland',
      heroSubtitle: 'Flerspråkig kundtjänst för grekiska företag.',
    },
    da: {
      title: 'Callcenter for Grækenland | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Grækenland: europæiske sprog, CSAT 95%, fra 3 $/t. 55% besparelse vs Athen.',
      heroTitle: 'Callcenter for Grækenland',
      heroSubtitle: 'Flersproget kundeservice for græske virksomheder.',
    },
    ko: {
      title: '그리스 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '그리스 콜센터: 유럽어 상담원, CSAT 95%, 시간당 $3부터. 아테네 대비 55% 절감.',
      heroTitle: '그리스 콜센터',
      heroSubtitle: '그리스 기업을 위한 다국어 고객 서비스.',
    },
    ja: {
      title: 'ギリシャ向けコールセンター | 多言語サポート | Call IT Dev',
      description: 'ギリシャ向けコールセンター：ヨーロッパ言語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'ギリシャ向けコールセンター',
      heroSubtitle: 'ギリシャ企業向け多言語カスタマーサービス。',
    },
    tr: {
      title: 'Yunanistan Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Yunanistan çağrı merkezi: Avrupa dilleri, CSAT %95, saat başı 3$\'dan. %55 tasarruf.',
      heroTitle: 'Yunanistan Çağrı Merkezi',
      heroSubtitle: 'Yunan şirketleri için çok dilli müşteri hizmetleri.',
    },
    nl: {
      title: 'Callcenter Griekenland | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Griekenland: Europese talen, CSAT 95%, vanaf 3 $/u. 55% besparing vs Athene.',
      heroTitle: 'Callcenter voor Griekenland',
      heroSubtitle: 'Meertalige klantenservice voor Griekse bedrijven.',
    },
  },

  // ============ KENYA — expand to SV, DA, KO, JA, TR, IT, PT, NL ============
  kenya: {
    sv: {
      title: 'Callcenter för Kenya | Engelsktalande Support | Call IT Dev',
      description: 'Callcenter för Kenya: engelska agenter, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för Kenya',
      heroSubtitle: 'Premium kundtjänst för kenyanska företag.',
    },
    da: {
      title: 'Callcenter for Kenya | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Kenya: engelske agenter, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter for Kenya',
      heroSubtitle: 'Premium kundeservice for kenyanske virksomheder.',
    },
    ko: {
      title: '케냐 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '케냐 콜센터: 영어 상담원, CSAT 95%, 시간당 $3부터.',
      heroTitle: '케냐 콜센터',
      heroSubtitle: '케냐 기업을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'ケニア向けコールセンター | 英語サポート | Call IT Dev',
      description: 'ケニア向けコールセンター：英語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'ケニア向けコールセンター',
      heroSubtitle: 'ケニア企業向けプレミアムカスタマーサービス。',
    },
    tr: {
      title: 'Kenya Çağrı Merkezi | İngilizce Müşteri Hizmetleri | Call IT Dev',
      description: 'Kenya çağrı merkezi: İngilizce temsilciler, CSAT %95, saat başı 3$\'dan.',
      heroTitle: 'Kenya Çağrı Merkezi',
      heroSubtitle: 'Kenya şirketleri için premium müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Kenya | Assistenza in Inglese | Call IT Dev',
      description: 'Call center per il Kenya: agenti inglesi, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per il Kenya',
      heroSubtitle: 'Assistenza clienti premium per aziende kenyane.',
    },
    pt: {
      title: 'Call Center Quénia | Suporte em Inglês | Call IT Dev',
      description: 'Call center para o Quénia: agentes em inglês, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para o Quénia',
      heroSubtitle: 'Suporte premium para empresas quenianas.',
    },
    nl: {
      title: 'Callcenter Kenia | Engelstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Kenia: Engelstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Kenia',
      heroSubtitle: 'Premium klantenservice voor Keniaanse bedrijven.',
    },
  },

  // ============ THAILAND — expand to SV, DA, KO, TR, IT, PT, NL ============
  thailand: {
    sv: {
      title: 'Callcenter för Thailand | Flerspråkig Support | Call IT Dev',
      description: 'Callcenter för Thailand: engelska agenter, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för Thailand',
      heroSubtitle: 'Flerspråkig kundtjänst för thailändska företag.',
    },
    da: {
      title: 'Callcenter for Thailand | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Thailand: engelske agenter, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter for Thailand',
      heroSubtitle: 'Flersproget kundeservice for thailandske virksomheder.',
    },
    ko: {
      title: '태국 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '태국 콜센터: 영어 상담원, CSAT 95%, 시간당 $3부터.',
      heroTitle: '태국 콜센터',
      heroSubtitle: '태국 기업을 위한 다국어 고객 서비스.',
    },
    tr: {
      title: 'Tayland Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Tayland çağrı merkezi: İngilizce temsilciler, CSAT %95, saat başı 3$\'dan.',
      heroTitle: 'Tayland Çağrı Merkezi',
      heroSubtitle: 'Tayland şirketleri için çok dilli müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Thailandia | Supporto Multilingue | Call IT Dev',
      description: 'Call center per la Thailandia: agenti inglesi, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per la Thailandia',
      heroSubtitle: 'Supporto multilingue per aziende thailandesi.',
    },
    pt: {
      title: 'Call Center Tailândia | Suporte Multilíngue | Call IT Dev',
      description: 'Call center para a Tailândia: agentes em inglês, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para a Tailândia',
      heroSubtitle: 'Suporte multilíngue para empresas tailandesas.',
    },
    nl: {
      title: 'Callcenter Thailand | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Thailand: Engelstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Thailand',
      heroSubtitle: 'Meertalige klantenservice voor Thaise bedrijven.',
    },
  },

  // ============ MALAYSIA — expand to SV, DA, KO, TR, IT, PT, NL ============
  malaysia: {
    sv: {
      title: 'Callcenter för Malaysia | Flerspråkig Support | Call IT Dev',
      description: 'Callcenter för Malaysia: engelska agenter, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för Malaysia',
      heroSubtitle: 'Flerspråkig kundtjänst för malaysiska företag.',
    },
    da: {
      title: 'Callcenter for Malaysia | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Malaysia: engelske agenter, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter for Malaysia',
      heroSubtitle: 'Flersproget kundeservice for malaysiske virksomheder.',
    },
    ko: {
      title: '말레이시아 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '말레이시아 콜센터: 영어 상담원, CSAT 95%, 시간당 $3부터.',
      heroTitle: '말레이시아 콜센터',
      heroSubtitle: '말레이시아 기업을 위한 다국어 고객 서비스.',
    },
    tr: {
      title: 'Malezya Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Malezya çağrı merkezi: İngilizce temsilciler, CSAT %95, saat başı 3$\'dan.',
      heroTitle: 'Malezya Çağrı Merkezi',
      heroSubtitle: 'Malezya şirketleri için çok dilli müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Malesia | Supporto Multilingue | Call IT Dev',
      description: 'Call center per la Malesia: agenti inglesi, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per la Malesia',
      heroSubtitle: 'Supporto multilingue per aziende malesi.',
    },
    pt: {
      title: 'Call Center Malásia | Suporte Multilíngue | Call IT Dev',
      description: 'Call center para a Malásia: agentes em inglês, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para a Malásia',
      heroSubtitle: 'Suporte multilíngue para empresas malaias.',
    },
    nl: {
      title: 'Callcenter Maleisië | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Maleisië: Engelstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Maleisië',
      heroSubtitle: 'Meertalige klantenservice voor Maleisische bedrijven.',
    },
  },

  // ============ PHILIPPINES — expand to SV, DA, TR, IT, PT, NL ============
  philippines: {
    sv: {
      title: 'Callcenter för Filippinerna | Engelsktalande Support | Call IT Dev',
      description: 'Callcenter för Filippinerna: engelska agenter, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för Filippinerna',
      heroSubtitle: 'Premium kundtjänst för filippinska företag.',
    },
    da: {
      title: 'Callcenter for Filippinerne | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Filippinerne: engelske agenter, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter for Filippinerne',
      heroSubtitle: 'Premium kundeservice for filippinske virksomheder.',
    },
    tr: {
      title: 'Filipinler Çağrı Merkezi | İngilizce Müşteri Hizmetleri | Call IT Dev',
      description: 'Filipinler çağrı merkezi: İngilizce temsilciler, CSAT %95, saat başı 3$\'dan.',
      heroTitle: 'Filipinler Çağrı Merkezi',
      heroSubtitle: 'Filipin şirketleri için premium müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Filippine | Assistenza in Inglese | Call IT Dev',
      description: 'Call center per le Filippine: agenti inglesi, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per le Filippine',
      heroSubtitle: 'Assistenza premium per aziende filippine.',
    },
    pt: {
      title: 'Call Center Filipinas | Suporte em Inglês | Call IT Dev',
      description: 'Call center para as Filipinas: agentes em inglês, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para as Filipinas',
      heroSubtitle: 'Suporte premium para empresas filipinas.',
    },
    nl: {
      title: 'Callcenter Filipijnen | Engelstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor de Filipijnen: Engelstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor de Filipijnen',
      heroSubtitle: 'Premium klantenservice voor Filipijnse bedrijven.',
    },
  },

  // ============ NIGERIA — expand to SV, DA, KO, JA, TR, IT, PT, NL ============
  nigeria: {
    sv: {
      title: 'Callcenter för Nigeria | Engelsktalande Support | Call IT Dev',
      description: 'Callcenter för Nigeria: engelska agenter, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för Nigeria',
      heroSubtitle: 'Premium kundtjänst för nigerianska företag.',
    },
    da: {
      title: 'Callcenter for Nigeria | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Nigeria: engelske agenter, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter for Nigeria',
      heroSubtitle: 'Premium kundeservice for nigerianske virksomheder.',
    },
    ko: {
      title: '나이지리아 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '나이지리아 콜센터: 영어 상담원, CSAT 95%, 시간당 $3부터.',
      heroTitle: '나이지리아 콜센터',
      heroSubtitle: '나이지리아 기업을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: 'ナイジェリア向けコールセンター | 英語サポート | Call IT Dev',
      description: 'ナイジェリア向けコールセンター：英語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'ナイジェリア向けコールセンター',
      heroSubtitle: 'ナイジェリア企業向けプレミアムカスタマーサービス。',
    },
    tr: {
      title: 'Nijerya Çağrı Merkezi | İngilizce Müşteri Hizmetleri | Call IT Dev',
      description: 'Nijerya çağrı merkezi: İngilizce temsilciler, CSAT %95, saat başı 3$\'dan.',
      heroTitle: 'Nijerya Çağrı Merkezi',
      heroSubtitle: 'Nijerya şirketleri için premium müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Nigeria | Assistenza in Inglese | Call IT Dev',
      description: 'Call center per la Nigeria: agenti inglesi, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per la Nigeria',
      heroSubtitle: 'Assistenza premium per aziende nigeriane.',
    },
    pt: {
      title: 'Call Center Nigéria | Suporte em Inglês | Call IT Dev',
      description: 'Call center para a Nigéria: agentes em inglês, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para a Nigéria',
      heroSubtitle: 'Suporte premium para empresas nigerianas.',
    },
    nl: {
      title: 'Callcenter Nigeria | Engelstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Nigeria: Engelstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Nigeria',
      heroSubtitle: 'Premium klantenservice voor Nigeriaanse bedrijven.',
    },
  },

  // ============ EGYPT — expand to SV, DA, KO, JA, TR, IT, PT, NL ============
  egypt: {
    sv: {
      title: 'Callcenter för Egypten | Arabisktalande Support | Call IT Dev',
      description: 'Callcenter för Egypten: arabiska agenter, CSAT 95%, från 3 $/h. 50% besparing vs Kairo.',
      heroTitle: 'Callcenter för Egypten',
      heroSubtitle: 'Premium arabisktalande kundtjänst.',
    },
    da: {
      title: 'Callcenter for Egypten | Arabisktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Egypten: arabiske agenter, CSAT 95%, fra 3 $/t. 50% besparelse vs Kairo.',
      heroTitle: 'Callcenter for Egypten',
      heroSubtitle: 'Premium arabisktalende kundeservice.',
    },
    ko: {
      title: '이집트 콜센터 | 아랍어 고객 서비스 | Call IT Dev',
      description: '이집트 콜센터: 아랍어 상담원, CSAT 95%, 시간당 $3부터. 카이로 대비 50% 절감.',
      heroTitle: '이집트 콜센터',
      heroSubtitle: '프리미엄 아랍어 고객 서비스.',
    },
    ja: {
      title: 'エジプト向けコールセンター | アラビア語サポート | Call IT Dev',
      description: 'エジプト向けコールセンター：アラビア語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'エジプト向けコールセンター',
      heroSubtitle: 'プレミアムアラビア語カスタマーサービス。',
    },
    tr: {
      title: 'Mısır Çağrı Merkezi | Arapça Müşteri Hizmetleri | Call IT Dev',
      description: 'Mısır çağrı merkezi: Arapça temsilciler, CSAT %95, saat başı 3$\'dan. %50 tasarruf.',
      heroTitle: 'Mısır Çağrı Merkezi',
      heroSubtitle: 'Premium Arapça müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Egitto | Assistenza in Arabo | Call IT Dev',
      description: 'Call center per l\'Egitto: agenti arabi, CSAT 95%, da 3 $/h. 50% risparmio vs Il Cairo.',
      heroTitle: 'Call Center per l\'Egitto',
      heroSubtitle: 'Assistenza clienti premium in arabo.',
    },
    pt: {
      title: 'Call Center Egito | Suporte em Árabe | Call IT Dev',
      description: 'Call center para o Egito: agentes em árabe, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para o Egito',
      heroSubtitle: 'Suporte premium em árabe.',
    },
    nl: {
      title: 'Callcenter Egypte | Arabischtalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Egypte: Arabischtalige agenten, CSAT 95%, vanaf 3 $/u. 50% besparing vs Caïro.',
      heroTitle: 'Callcenter voor Egypte',
      heroSubtitle: 'Premium Arabischtalige klantenservice.',
    },
  },

  // ============ SOUTH AFRICA — expand to SV, DA, KO, JA, TR, IT, PT, NL ============
  'south-africa': {
    sv: {
      title: 'Callcenter för Sydafrika | Engelsktalande Support | Call IT Dev',
      description: 'Callcenter för Sydafrika: engelska agenter, CSAT 95%, från 3 $/h. 60% besparing vs Johannesburg.',
      heroTitle: 'Callcenter för Sydafrika',
      heroSubtitle: 'Premium kundtjänst för sydafrikanska företag.',
    },
    da: {
      title: 'Callcenter for Sydafrika | Engelsktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Sydafrika: engelske agenter, CSAT 95%, fra 3 $/t. 60% besparelse vs Johannesburg.',
      heroTitle: 'Callcenter for Sydafrika',
      heroSubtitle: 'Premium kundeservice for sydafrikanske virksomheder.',
    },
    ko: {
      title: '남아프리카 콜센터 | 영어 고객 서비스 | Call IT Dev',
      description: '남아프리카 콜센터: 영어 상담원, CSAT 95%, 시간당 $3부터. 요하네스버그 대비 60% 절감.',
      heroTitle: '남아프리카 콜센터',
      heroSubtitle: '남아프리카 기업을 위한 프리미엄 고객 서비스.',
    },
    ja: {
      title: '南アフリカ向けコールセンター | 英語サポート | Call IT Dev',
      description: '南アフリカ向けコールセンター：英語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: '南アフリカ向けコールセンター',
      heroSubtitle: '南アフリカ企業向けプレミアムカスタマーサービス。',
    },
    tr: {
      title: 'Güney Afrika Çağrı Merkezi | İngilizce Müşteri Hizmetleri | Call IT Dev',
      description: 'Güney Afrika çağrı merkezi: İngilizce temsilciler, CSAT %95, saat başı 3$\'dan. %60 tasarruf.',
      heroTitle: 'Güney Afrika Çağrı Merkezi',
      heroSubtitle: 'Güney Afrika şirketleri için premium müşteri hizmetleri.',
    },
    it: {
      title: 'Call Center Sudafrica | Assistenza in Inglese | Call IT Dev',
      description: 'Call center per il Sudafrica: agenti inglesi, CSAT 95%, da 3 $/h. 60% risparmio.',
      heroTitle: 'Call Center per il Sudafrica',
      heroSubtitle: 'Assistenza premium per aziende sudafricane.',
    },
    pt: {
      title: 'Call Center África do Sul | Suporte em Inglês | Call IT Dev',
      description: 'Call center para a África do Sul: agentes em inglês, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para a África do Sul',
      heroSubtitle: 'Suporte premium para empresas sul-africanas.',
    },
    nl: {
      title: 'Callcenter Zuid-Afrika | Engelstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Zuid-Afrika: Engelstalige agenten, CSAT 95%, vanaf 3 $/u. 60% besparing.',
      heroTitle: 'Callcenter voor Zuid-Afrika',
      heroSubtitle: 'Premium klantenservice voor Zuid-Afrikaanse bedrijven.',
    },
  },

  // ============ SAUDI ARABIA — expand to SV, DA, KO, JA ============
  'saudi-arabia': {
    sv: {
      title: 'Callcenter för Saudiarabien | Arabisktalande Support | Call IT Dev',
      description: 'Callcenter för Saudiarabien: arabiska agenter, CSAT 95%, från 3 $/h. 65% besparing vs Riyadh.',
      heroTitle: 'Callcenter för Saudiarabien',
      heroSubtitle: 'Premium arabisktalande kundtjänst.',
    },
    da: {
      title: 'Callcenter for Saudi-Arabien | Arabisktalende Kundeservice | Call IT Dev',
      description: 'Callcenter for Saudi-Arabien: arabiske agenter, CSAT 95%, fra 3 $/t. 65% besparelse vs Riyadh.',
      heroTitle: 'Callcenter for Saudi-Arabien',
      heroSubtitle: 'Premium arabisktalende kundeservice.',
    },
    ko: {
      title: '사우디아라비아 콜센터 | 아랍어 고객 서비스 | Call IT Dev',
      description: '사우디아라비아 콜센터: 아랍어 상담원, CSAT 95%, 시간당 $3부터. 리야드 대비 65% 절감.',
      heroTitle: '사우디아라비아 콜센터',
      heroSubtitle: '프리미엄 아랍어 고객 서비스.',
    },
    ja: {
      title: 'サウジアラビア向けコールセンター | アラビア語サポート | Call IT Dev',
      description: 'サウジアラビア向けコールセンター：アラビア語エージェント、CSAT 95%、時給3ドルから。',
      heroTitle: 'サウジアラビア向けコールセンター',
      heroSubtitle: 'プレミアムアラビア語カスタマーサービス。',
    },
  },
};
